<template>
  <div data-page="page-not-found">
    <div class="typography">
      <h1>{{ $t('page-not-found-headline') }}</h1>
      <p>{{ $t('page-not-found-subheadline') }}</p>
      <p><a :href="$t('page-not-found-link-url')">{{ $t('page-not-found-link-title') }}</a></p>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  mounted() {
    document.body.classList.remove('loading');
  }
}
</script>

<style lang="scss">
[data-page=page-not-found] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  padding: max(40px, 5vh) var(--wrapper-padding-right) max(40px, 5vh) var(--wrapper-padding-left);
  .typography {
    max-width: 800px;
    text-align: center;
  }
}
</style>
